import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "dprd_admin_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401 for authenticated routes, clear token so AuthProvider re-checks
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("auth:logout"));
    }
    return Promise.reject(err);
  }
);

export const listVisitors = (params = {}) => api.get("/visitors", { params }).then(r => r.data);
export const getVisitor = (id) => api.get(`/visitors/${id}`).then(r => r.data);
export const createVisitor = (data) => api.post("/visitors", data).then(r => r.data);
export const updateVisitor = (id, data) => api.put(`/visitors/${id}`, data).then(r => r.data);
export const deleteVisitor = (id) => api.delete(`/visitors/${id}`).then(r => r.data);
export const getStats = () => api.get("/visitors/stats").then(r => r.data);
export const exportCsvUrl = () => `${API}/visitors/export/csv`;
export const exportXlsxUrl = () => `${API}/visitors/export/xlsx`;
export const bulkFetch = (ids) => api.post("/visitors/bulk-fetch", { ids }).then(r => r.data);

export const getSettings = () => api.get("/settings").then(r => r.data);
export const updateSettings = (data) => api.put("/settings", data).then(r => r.data);

export const changePassword = (current_password, new_password) =>
  api.post("/auth/change-password", { current_password, new_password }).then(r => r.data);

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data; // { path, url, size }
};

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);
